module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "esocial-config-card"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]), _vm._v(" "), (_vm.lastUpdate.usuario) ? _c('ed-alert', {
    staticClass: "mt-1",
    attrs: {
      "type": "success",
      "title": "Última Atualização",
      "description": _vm.lastUpdate.usuario.usuario + ' em ' + _vm.toDate(_vm.lastUpdate.updated_at)
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "esocial-config-header"
  }, [_c('div', {
    staticClass: "esocial-config-header__icon"
  }, [_c('i', {
    staticClass: "fa fa-cogs",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "esocial-config-header__title"
  }, [_vm._v("Configurações do eSocial")]), _vm._v(" "), _c('p', {
    staticClass: "esocial-config-header__subtitle"
  }, [_vm._v("\n          Defina se e quando os lotes de eventos são gerados e enviados automaticamente para o eSocial.\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c01ab358"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/configuracao/index.vue
// module id = 1585
// module chunks = 45